<script setup lang="ts">
import { defineProps, computed } from "vue";
import { FavorableDayReport } from "@/types/calculators";
import { useI18n } from "vue-i18n";
import UnexistGoodDoingComponent from "@/views/Calculators/PersonalDates/components/dayReport/UnexistGoodDoingComponent.vue";
import DoingCardComponent from "@/views/Calculators/PersonalDates/components/dayReport/DoingCardComponent.vue";

const props = defineProps<{
  dayDetailsInfo: FavorableDayReport;
  activityScope: string;
}>();

const { t } = useI18n();
const isDayHasUnexistGoodDoings = computed(() => {
  return (
    props.dayDetailsInfo.day_report.general.yi_ji_activities.yi.length === 0 &&
    props.dayDetailsInfo.day_report.general.yi_ji_activities.ji.length > 0 &&
    props.dayDetailsInfo.day_report.general.yi_ji_activities.ji[0].name ===
      "诸事不宜"
  );
});
</script>

<template>
  <div
    class="lg:col-span-2 bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-5"
  >
    <div class="flex items-center justify-between pb-3 border-b border-divider">
      <div>
        <h2
          class="text-base sm:text-lg font-bold text-brown flex items-center gap-2"
        >
          <span>
            {{ t("calculators.personal-date.full-day-report.doings-title") }}
          </span>
          <span class="text-xs font-normal text-muted font-caudex">
            (宜忌指南)
          </span>
        </h2>
      </div>
      <span
        class="text-xs px-2.5 py-1 bg-secondary rounded-lg text-alternative-gray border border-divider"
      >
        {{ activityScope }}
      </span>
    </div>
    <div class="p-4 rounded-xl border border-success/30 bg-[#F9FCFA]">
      <div class="flex items-center gap-2 mb-3">
        <span
          class="w-6 h-6 rounded-full bg-success text-white flex items-center justify-center text-xs font-bold font-caudex"
        >
          宜
        </span>
        <h3 class="font-bold text-brown text-sm">
          {{ t("calculators.personal-date.full-day-report.favorable-doings") }}
        </h3>
      </div>
      <UnexistGoodDoingComponent v-if="isDayHasUnexistGoodDoings" />
      <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        <DoingCardComponent
          v-for="doing in dayDetailsInfo.day_report.general.yi_ji_activities.yi"
          :activity="doing"
          :isPositive="true"
          :key="doing.code"
        />
      </div>
    </div>
    <div class="p-4 rounded-xl border border-error/30 bg-[#FDF7F7]">
      <div class="flex items-center gap-2 mb-3">
        <span
          class="w-6 h-6 rounded-full bg-error text-white flex items-center justify-center text-xs font-bold font-caudex"
        >
          忌
        </span>
        <h3 class="font-bold text-brown text-sm">
          {{
            t("calculators.personal-date.full-day-report.unfavorable-doings")
          }}
        </h3>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        <DoingCardComponent
          v-for="doing in dayDetailsInfo.day_report.general.yi_ji_activities.ji"
          :activity="doing"
          :isPositive="false"
          :key="doing.code"
        />
      </div>
    </div>
  </div>
</template>
